import { useState } from 'react';
import { Link } from 'react-router-dom';
import { rankings, comics } from '@/mocks/comics';

type RankingTab = 'popularity' | 'weekly';

export default function RankingSection() {
  const [tab, setTab] = useState<RankingTab>('popularity');

  const tabs: { key: RankingTab; label: string }[] = [
    { key: 'popularity', label: '人气榜' },
    { key: 'weekly', label: '周榜' },
  ];

  const rankList = rankings[tab].slice(0, 10);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">
              排行榜
            </h2>
            <p className="text-sm text-foreground-500">热门漫画实时排行</p>
          </div>
          <div className="flex items-center bg-background-200/70 rounded-full p-1">
            {tabs.map((t) => (
              <button
                key={t.key}
                onClick={() => setTab(t.key)}
                className={`px-4 py-1.5 text-sm font-medium rounded-full transition-all whitespace-nowrap cursor-pointer ${
                  tab === t.key
                    ? 'bg-background-50 text-foreground-900'
                    : 'text-foreground-500 hover:text-foreground-700'
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
          {rankList.slice(0, 5).map((item) => {
            const comic = comics.find((c) => c.id === item.comicId);
            if (!comic) return null;
            return (
              <Link
                key={item.rank}
                to={`/comic/${comic.id}`}
                className="group flex lg:flex-col gap-3 p-4 bg-background-50 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="relative w-[72px] lg:w-full aspect-[3/4] flex-shrink-0 rounded-md lg:rounded-lg overflow-hidden bg-background-200">
                  <img
                    src={comic.cover}
                    alt={`${comic.title} - 漫画排行榜TOP${item.rank}`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-0 left-0 w-7 h-7 flex items-center justify-center bg-foreground-900/80 text-background-50 text-xs font-bold rounded-br-lg">
                    {item.rank}
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                  <div className="flex items-center gap-2 mt-2">
                    <i className="ri-star-fill text-amber-400 text-xs"></i>
                    <span className="text-xs text-foreground-700 font-medium">{comic.rating}</span>
                    <span className="text-xs text-accent-500 ml-auto">
                      {item.change === 'up' ? '↑' : item.change === 'down' ? '↓' : item.change === 'new' ? '🆕' : '—'}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}